import { Col, Row } from "reactstrap";
import LinkCards from "../../components/ContentManagement/LinkCards";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { DASHBOARD_ROOT } from "../../components/Routes/routingConstants";

const ContentManagementPage = () => {

    const linkBase = `${DASHBOARD_ROOT}/content-management`
    const breadcrumbsData = [
        { name: "Content List", path: linkBase },
    ];

    interface ContentList {
        name : string;
        url : string;
        tag : string;
    }

    interface TagList {
        name : string;
        label : string;
    }

    const tags : TagList[] = [ 
        {
            name : "organisations",
            label : "User and Organisations"
        },
        {
            name : "dashboard",
            label : "Dashboard Contents"
        },
        {
            name : "empower.me",
            label : "Empower ME Contents"
        },
        {
            name : "sequence",
            label : "Day Sequence"
        },
        {
            name : "questionnaires",
            label : "Questionnaires"
        },
        {
            name : "onboarding",
            label : "Onboarding"
        },
        {
            name : "content",
            label : "Libaries"
        },
    ]

    const contentList : ContentList[] = [
        {
            name : "Organisation List",
            url : `${linkBase}/organisation-list`,
            tag : "organisations"
        },
        {
            name : "User Master List",
            url : `/management/users`,
            tag : "organisations"
        },
        {
            name : "Challenge of the Week",
            url : `${linkBase}/challenge-of-the-week`,
            tag : "dashboard"
        },
        {
            name : "Health Hub",
            url : `${linkBase}/health-hub`,
            tag : "dashboard"
        },
        // {
        //     name : "User Progress",
        //     url : `${linkBase}/user-progress`,
        //     tag : "dashboard"
        // },
        {
            name : "Empower Me Nudge Categories",
            url : `${linkBase}/empower-me/categories`,
            tag : "empower.me"
        },
        {
            name : "Empower Me Nudges",
            url : `${linkBase}/empower-me`,
            tag : "empower.me"
        },
        {
            name : "Empower Me Nudge Bundles",
            url : `${linkBase}/empower-me/bundles`,
            tag : "empower.me"
        },
        {
            name : "Sequence Management",
            url : `${linkBase}/day-sequences`,
            tag : "sequence"
        },
        {
            name : "Sequence Buckets",
            url : `${linkBase}/day-sequences/buckets`,
            tag : "sequence"
        },
        {
            name : "Questionnaires",
            url : `${linkBase}/questionnaires`,
            tag : "questionnaires"
        },
        {
            name : "Questionnaires Answers",
            url : `${linkBase}/questionnaires-answers`,
            tag : "questionnaires"
        },
        {
            name : "Onboarding Videos",
            url : `${linkBase}/onboarding-videos`,
            tag : "onboarding"
        },
        {
            name : "Multi Library",
            url : `${linkBase}/multi-library`,
            tag : "content"
        },
        {
            name : "Image Library",
            url : `${linkBase}/library/images`,
            tag : "content"
        },
        {
            name : "Video Library",
            url : `${linkBase}/library/videos`,
            tag : "content"
        },
    ]
    return (
        <>
            <Breadcrumbs 
                crumbs={breadcrumbsData}
            />
            {tags.map( (tag, tagIndex) =>{

                return (
                    <div key={tagIndex}>
                        <h3 className={tagIndex !== 0 ? "pt-4" : ""}>{tag.label}</h3>
                        <Row>
                        {contentList.filter(u=>u.tag===tag.name).map((item,index) => {
                            return (
                                <Col  md="4" className="text-center" key={index} >
                                    <LinkCards
                                        link={item}
                                    /> 
                                </Col>
                            )
                        })}
                    </Row>
                    </div>
                )

            } )}
        </>
    )
}
export { ContentManagementPage as ContentManagement };